import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyPoints97Icon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./Points97Icon-b4789b64.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyPoints97Icon as P };
